import { usePreferredDesignersListQuery } from './PreferredDesignersList.generated';

export const PREFERRED_DESIGNERS_PAGE_SIZE = 20;

export function usePreferredDesignerCount(isPreferredDesignerBrief: boolean) {
    const { data, loading } = usePreferredDesignersListQuery({
        variables: { page: 1, pageSize: PREFERRED_DESIGNERS_PAGE_SIZE },
        skip: !isPreferredDesignerBrief,
        errorPolicy: 'all',
    });

    return {
        count: data?.myDesigners.designers.length ?? 0,
        loading,
    };
}
